const moreOptions = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M2.13 4.28C1.506 4.28 1 3.77 1 3.14 1 2.51 1.506 2 2.13 2c.624 0 1.13.51 1.13 1.14 0 .63-.506 1.14-1.13 1.14m2.43-1.87H15v1.46H4.56zM2.13 9.14C1.506 9.14 1 8.63 1 8c0-.63.506-1.14 1.13-1.14.624 0 1.13.51 1.13 1.14 0 .63-.506 1.14-1.13 1.14m2.43-1.87H15v1.46H4.56zM2.13 14C1.506 14 1 13.49 1 12.86c0-.63.506-1.14 1.13-1.14.624 0 1.13.51 1.13 1.14 0 .63-.506 1.14-1.13 1.14m2.43-1.87H15v1.46H4.56z"/></svg>',
};

export { moreOptions as default };
